import { createSelector } from 'reselect';

const getIsAppConfig = (state) => {
    const { views: { view }, config = {} } = state;
    return config[view]?.isApp ?? config?.isApp ?? false;
};

export const getIsAppConfigState = createSelector(
    [getIsAppConfig],
    (isApp) => {
        return isApp;
    }
);
